












import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { SignDigitalSignatureSignedViewModelGen } from "@/services/sign/v1/data-contracts";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import ContextMenu from "../utility/ContextMenu.vue";
import TimelineCard from "../utility/TimelineItem.vue";
import ActivityTimeLineItemDelete from "./ActivityTimeLineItemDelete.vue";
import { SIGN_COLOR_BY_STATUS } from "@/views/sign/SignRequestTable.vue";

@Component({
  components: {
    TimelineCard,
    ActivityTimeLineItemDelete,
    ContextMenu
  }
})
export default class ActivityTimeLineItemSignedCard extends mixins(DarkModeHighlightMixin, PermissionMixin) {
  @Prop({})
  isLoading = false;

  @Prop()
  document!: SignDigitalSignatureSignedViewModelGen;

  get colorByStatus() {
    return SIGN_COLOR_BY_STATUS;
  }

  get title() {
    if (this.document && this.document.title) {
      return this.document.title;
    } else {
      return this.$t("timeLine.ActivityTimeLineItemDocument.sharedDocument");
    }
  }
}
